





































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class NavigationBar extends Vue {
  private dashboardUrl: string = process.env.VUE_APP_DASHBOARD_URL!;
  private loginUrl: string = process.env.VUE_APP_LOGIN_URL!;
  private navbarMenuIsActive: boolean = false;

  private handleLogout(): void {
    (this as any).$auth0.logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  }
}
